<template>
  <page-outline :title="$t('account_tb.account_tb_details')">
    <template slot="pageContent">
      <b-container fluid>
        <b-row class="justify-content-start mb-5">
          <b-col cols="2">
            <back-button></back-button>
          </b-col>
          <b-col cols="2" @click="refresh">
            <b-button class="back-button">
              <i class="fa-solid fa-rotate-right fs-14px"></i>
              {{ $t('common.rfrsh') }}
            </b-button>
          </b-col>
          <b-col cols="2" @click="reset">
            <b-button class="back-button">
              <i class="fa-solid fa-eraser fs-14px"></i>
              {{ $t('common.rst') }}
            </b-button>
          </b-col>
        </b-row>


        <spinner v-if="activateSpinnerBooks"></spinner>
        <template v-else-if="Books">
          <div>
            <form-accordion :title="$t('account_tb.organisation_info')" :isTitleUpperCase="false">
              <table class="table table-striped my-5" v-if="AccountTB.Name">
                <tbody>
                <tr>
                  <th class="text-center w-25">
                    {{ $t('account_tb.name') }}
                  </th>
                  <th class="text-center w-25">
                    {{ $t('account_tb.email') }}
                  </th>
                  <th class="text-center w-25">
                    {{ $t('account_tb.organisation_type') }}
                  </th>
                  <th class="text-center w-25">
                    {{ $t('account_tb.phase') }}
                  </th>
                </tr>
                <tr>
                  <td class="text-center w-25">
                    <div>{{AccountTB.Name }}</div>
                  </td>
                  <td class="text-center w-25">
                    <div>{{ AccountTB.Email}}</div>
                  </td>
                  <td class="text-center w-25">
                    <div>{{ AccountTB.IsRVM == '1' ? 'RVM' : 'PSP' }}</div>
                  </td>
                  <td class="text-center w-25">
                    <div>{{ AccountTB.Phase }}</div>
                  </td>
                </tr>
                </tbody>
              </table>
            </form-accordion>
          </div>
          <hr class="mx-auto" />
          <div>
            <form-accordion :title="$t('account_tb.users')" :isTitleUpperCase="false">
              <table class="table table-striped my-5" v-if="AccountTB.Users && AccountTB.Users.length">
                <tbody>
                <tr>
                  <th class="text-center w-25">
                    {{ $t('account_tb.login') }}
                  </th>
                  <th class="text-center w-25">
                    {{ $t('account_tb.date_last_session') }}
                  </th>
                  <th class="text-center w-25">
                    {{ $t('account_tb.date_creation') }}
                  </th>
                </tr>
                <tr v-for="user in AccountTB.Users" :key="user.IdUserAccount">
                  <td class="text-center w-25">
                    <div>{{ user.Login }}</div>
                  </td>
                  <td class="text-center w-25">
                    <div>{{ getDate(user.DateLastSession) }}</div>
                  </td>
                  <td class="text-center w-25">
                    <div>{{ getDate(user.DateCreation) }}</div>
                  </td>
                </tr>
                </tbody>
              </table>
              <div v-else class="d-flex justify-content-center">
                    <span class="noResult">
                      {{ $t('account_tb.no_users') }}
                    </span>
              </div>
            </form-accordion>
          </div>
          <hr class="mx-auto" />
          <div>
            <form-accordion :title="$t('account_tb.booking')" :isTitleUpperCase="false">
              <table class="table table-striped my-5" v-if="Books && Books.length">
                <tbody>
                <tr>
                  <th class="text-center w-25">
                    {{ $t('account_tb.date_start') }}
                  </th>
                  <th class="text-center w-25">
                    {{ $t('account_tb.date_end') }}
                  </th>
                  <th class="text-center w-25">
                    {{ $t('account_tb.session_number') }}
                  </th>
                  <th class="text-center w-25">
                    {{ $t('account_tb.status_session') }}
                  </th>
                </tr>
                <tr v-for="(books, index) in Books" :key="index">
                  <td class="text-center w-25">
                    <div>{{ getDate(books.DateStart) }}</div>
                  </td>
                  <td class="text-center w-25">
                    <div>{{ getDate(books.DateEnd) }}</div>
                  </td>
                  <td class="text-center w-25">
                    <div>{{ books.SessionNumber }}</div>
                  </td>
                  <td class="text-center w-25">
                    <div>{{ getBookStatus(books.DateStart, books.DateEnd) }}</div>
                  </td>
                </tr>
                </tbody>
              </table>
              <div v-else class="d-flex justify-content-center">
                    <span class="noResult">
                      {{ $t('account_tb.no_books') }}
                    </span>
              </div>
            </form-accordion>
          </div>
          <hr class="mx-auto" />
          <div>
            <form-accordion :title="$t('account_tb.test_validation')" :isTitleUpperCase="false">
              <b-button-group class="mt-3 mt-sm-0" style="display:grid;grid-auto-flow:column;">
                <b-button
                    class="responsive-button"
                    v-for="(tab, index) in tabs"
                    :key="index"
                    :variant="tabName === index ? 'primary' : 'secondary'"
                    @click="tabName = index">
                  {{ $t(tab.translationKey) }}
                </b-button>
              </b-button-group>

              <b-tabs v-model="tabName" @input="onTabChange"  nav-class="d-none">
                <b-tab :title="$t('account_tb.all')">
                  <b-row class="justify-content-center mt-5">
                    <spinner v-if="activateSpinnerTest"></spinner>
                    <b-col v-else-if="pieChartDataAll" cols="12">
                      <h3 class="text-center">
                        {{ $t("account_tb.all") }}
                      </h3>
                      <pie-chart :key="resetChartAll"
                          ref="pieChartAll"
                          :chart-data="pieChartDataAll"
                          :options="chartOptionsAll">
                      </pie-chart>
                    </b-col>
                    <div v-else class="d-flex justify-content-center">
                    <span class="noResult">
                      {{ $t('account_tb.no_data') }}
                    </span>
                    </div>
                  </b-row>
                </b-tab>
                <b-tab :title="$t('account_tb.responder')">
                  <b-row class="justify-content-center mt-5">
                    <spinner v-if="activateSpinnerTest"></spinner>
                    <b-col v-else-if="pieChartDataRes" cols="12">
                      <h3 class="text-center">
                        {{ $t("account_tb.responder") }}
                      </h3>
                      <pie-chart :key="resetChartRes"
                          ref="pieChartRes"
                          :chart-data="pieChartDataRes"
                          :options="chartOptionsRes">
                      </pie-chart>
                    </b-col>
                    <div v-else class="d-flex justify-content-center">
                    <span class="noResult">
                      {{ $t('account_tb.no_data') }}
                    </span>
                    </div>
                  </b-row>
                </b-tab>
                <b-tab :title="$t('account_tb.requester')">
                  <b-row class="justify-content-center mt-5">
                    <spinner v-if="activateSpinnerTest"></spinner>
                    <b-col v-else-if="pieChartDataReq" cols="12">
                      <h3 class="text-center">
                        {{ $t("account_tb.requester") }}
                      </h3>
                      <pie-chart :key="resetChartReq"
                          ref="pieChartReq"
                          :chart-data="pieChartDataReq"
                          :options="chartOptionsReq">
                      </pie-chart>
                    </b-col>
                    <div v-else class="d-flex justify-content-center">
                    <span class="noResult">
                      {{ $t('account_tb.no_data') }}
                    </span>
                    </div>
                  </b-row>
                </b-tab>
              </b-tabs>
            </form-accordion>
          </div>

        </template>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'
import backButton from "@/components/common/backButton.vue"
import Spinner from '@/components/common/spinner.vue'
import formAccordion from "@/components/common/FormAccordion.vue"
import FormReadGroupLabelInput from "@/components/common/formReadGroupLabelInput.vue"
import {errorMessageAlert} from "@/helpers/alert"
import moment from "moment"
import alpha2Country from "../../data/alpha2Country.json"
import {Pie} from "vue-chartjs";
import ChartDataLabels from "chartjs-plugin-datalabels";

export default {
  name: 'AccountTBDetails',
  components: {
    FormReadGroupLabelInput,
    'page-outline': PageOutline,
    'back-button': backButton,
    'spinner': Spinner,
    'form-accordion': formAccordion,
    "pie-chart": {
      extends: Pie,
      props: ["chartData", "options"],
      mounted() {
        this.$nextTick(() => {
          this.addPlugin(ChartDataLabels)
          this.renderChart(this.chartData, this.options)
        })
      }
    }
  },
  computed: {
    listTitle () {
      return this.$t('tracking.tracks_details')
    }
  },
  props: ['id', 'type'],
  data () {
    return {
      activateSpinnerTest: false,
      activateSpinner: false,
      activateSpinnerBooks: false,
      countries: alpha2Country.countries.reverse(),
      returnUrl: '',
      tabName: 0,
      tabs: [
        { translationKey: 'account_tb.all' },
        { translationKey: 'account_tb.responder' },
        { translationKey: 'account_tb.requester' },
      ],
      chartOptionsAll: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            formatter: (value, ctx) => {
              let total = ctx.chart.data.datasets[0].data.reduce(
                  (a, b) => a + b,
                  0
              )
              let percentage = ''
              if (total !== 0 && value !== 0) {
                percentage = ((value / total) * 100).toFixed(2) + "%"
              }
              return percentage
            },
            color: "#000",
            font: {
              weight: "bold",
            },
          }
        }
      },
      chartOptionsReq: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            formatter: (value, ctx) => {
              let total = ctx.chart.data.datasets[0].data.reduce(
                  (a, b) => a + b,
                  0
              )
              let percentage = ''
              if (total !== 0 && value !== 0) {
                percentage = ((value / total) * 100).toFixed(2) + "%"
              }
              return percentage
            },
            color: "#000",
            font: {
              weight: "bold",
            },
          }
        }
      },
      chartOptionsRes: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            formatter: (value, ctx) => {
              let total = ctx.chart.data.datasets[0].data.reduce(
                  (a, b) => a + b,
                  0
              )
              let percentage = ''
              if (total !== 0 && value !== 0) {
                percentage = ((value / total) * 100).toFixed(2) + "%"
              }
              return percentage
            },
            color: "#000",
            font: {
              weight: "bold",
            },
          }
        }
      },
      pieChartDataRes: null,
      pieChartDataAll: null,
      pieChartDataReq: null,
      AccountTB: [],
      Books: [],
      resetChartReq: false,
      resetChartRes: false,
      resetChartAll: false
    }
  },
  onDestroy () {
        this.tabs = [
      { translationKey: 'account_tb.all' },
      { translationKey: 'account_tb.responder' },
      { translationKey: 'account_tb.requester' },
    ],
        this.chartOptionsAll = {
      responsive: true,
          maintainAspectRatio: false,
          plugins: {
        datalabels: {
          formatter: (value, ctx) => {
            let total = ctx.chart.data.datasets[0].data.reduce(
                (a, b) => a + b,
                0
            )
            let percentage = ''
            if (total !== 0 && value !== 0) {
              percentage = ((value / total) * 100).toFixed(2) + "%"
            }
            return percentage
          },
              color: "#000",
              font: {
            weight: "bold",
          },
        }
      }
    },
        this.chartOptionsReq = {
      responsive: true,
          maintainAspectRatio: false,
          plugins: {
        datalabels: {
          formatter: (value, ctx) => {
            let total = ctx.chart.data.datasets[0].data.reduce(
                (a, b) => a + b,
                0
            )
            let percentage = ''
            if (total !== 0 && value !== 0) {
              percentage = ((value / total) * 100).toFixed(2) + "%"
            }
            return percentage
          },
              color: "#000",
              font: {
            weight: "bold",
          },
        }
      }
    },
        this.chartOptionsRes = {
      responsive: true,
          maintainAspectRatio: false,
          plugins: {
        datalabels: {
          formatter: (value, ctx) => {
            let total = ctx.chart.data.datasets[0].data.reduce(
                (a, b) => a + b,
                0
            )
            let percentage = ''
            if (total !== 0 && value !== 0) {
              percentage = ((value / total) * 100).toFixed(2) + "%"
            }
            return percentage
          },
              color: "#000",
              font: {
            weight: "bold",
          },
        }
      }
    },
        this.pieChartDataRes = null,
        this.pieChartDataAll = null,
        this.pieChartDataReq = null,
        this.AccountTB = [],
        this.Books = []
  },
  watch: {
    tabName(newVal) {
      this.onTabChange(newVal)
    }
  },
  created () {
    this.activateSpinnerTest = true
    this.activateSpinnerBooks = true
    this.idAccountTBBulk = this.$route.query.idAccountTBBulk
    this.defineReturnURL()
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: 'Details de l\'utilisateur'
    })

    this.$engine.settings.set({msgDirection: this.direction})
    this.fetchAccountTB()
    this.fetchTestTB()
    this.fetchBookingTB()
    this.$f7.initPullToRefresh()
    this.pageCounter = 0


    this.filterTypeGet = this.filterType
    this.$bus.$emit('right-panel-set-feature', 'filter-messages')
  },
  methods: {
    onTabChange(index) {
      this.$nextTick(() => {
        const charts = [
          {
            ref: this.$refs.pieChartAll,
            data: this.pieChartDataAll,
            options: this.chartOptionsAll
          },
          {
            ref: this.$refs.pieChartRes,
            data: this.pieChartDataRes,
            options: this.chartOptionsRes
          },
          {
            ref: this.$refs.pieChartReq,
            data: this.pieChartDataReq,
            options: this.chartOptionsReq
          }
        ]

        const chart = charts[index]

        if (chart.ref.chart) {
          chart.ref.chart.resize()
        } else {
          chart.ref.renderChart(chart.data, chart.options)
        }
      })
    },
    getBookStatus(DateStart, DateEnd) {
      const now = new Date();

      if (DateEnd < now) {
        return this.$t("account_tb.status.past")
      } else if (DateStart > now) {
        return this.$t("account_tb.status.future")
      } else {
        return this.$t("account_tb.status.current")
      }
    },
    getDate(date){
      if (date == '' || date == undefined){
        return '-'
      }
      else {
        return moment.utc(date).local().format('DD/MM/YYYY HH:mm:ss')
      }
    },
    refresh (){
      this.fetchAccountTB()
      this.fetchTestTB()
      this.fetchBookingTB()
    },
    reset(){
      let that = this
      let filterConditions = {
        IdAccountTB: this.id
      }
      that.$engine.accountTB.resetAccountTB(
          filterConditions
      )
          .then(resp => {
            that.fetchTestTB()
          })
          .catch(error => {
            this.activateSpinner = false
            errorMessageAlert(error, that, that.$i18n)
          })
    },
    defineReturnURL() {
      let that = this
      let type = parseInt(this.type, 10)
      if (!isNaN(type) && this.type == type){
        this.returnUrl =  '/tracking/BULKDETAILS/'+ this.type
      }else{
        if (this.idAccountTBBulk !== undefined) {
          this.returnUrl = '/trackingbulk/' + this.idAccountTBBulk
        }
        else {
          this.returnUrl =  '/tracking/'+ this.type+'/NULL'
        }
      }
    },
    fetchAccountTB () {
      this.pageCounter = 0
      this.activateSpinner = true
      let that = this
      that.$engine.usercompany.idUserAcc = this.idUserAcc
      this.UsersList = []
      let filterConditions = {
        IdAccountTB: this.id
      }
      that.$engine.accountTB.getAccountTB(
        filterConditions
      )
      .then(resp => {
        let requests = {}
        if (resp.data && resp.data.accounts && resp.data.accounts.length) {
          that.AccountTB = resp.data.accounts[0]
        }
        this.activateSpinner = false
      })
      .catch(error => {
        this.activateSpinner = false
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    generatePieChartDataStatus(data) {
      let types = ['all', 'req', 'resp'];
      let pieChartData = {};

      types.forEach((type) => {
        let filteredResponses = data.filter((item) => {
          if (type === 'all') {
            return item.Type === 'resp' || item.Type === 'req';
          }
          return item.Type === type;
        });

        let statusCounts = {
          OK: 0,
          KO: 0,
          NULL: 0,
          CONF_NOT_FOUND: 0,
        };

        filteredResponses.forEach((item) => {
          switch (item.Status) {
            case '2':
              statusCounts.OK++
              break
            case '0':
              statusCounts.KO++
              break
            case '3':
              if (type === 'resp' || type == 'all') statusCounts.CONF_NOT_FOUND++
              break
            default:
              statusCounts.NULL++
              break
          }
        });

        let labels = [this.$t('account_tb.status.OK'), this.$t('account_tb.status.KO'), this.$t('account_tb.status.NULL')]
        let dataValues = [statusCounts.OK, statusCounts.KO, statusCounts.NULL]
        let colors = [
          this.getCustomColor('OK', 0.8),
          this.getCustomColor('KO', 0.8),
          this.getCustomColor('NULL', 0.8),
        ]

        if (type === 'resp' || type === 'all') {
          labels.push(this.$t('account_tb.status.CONF_NOT_FOUND'))
          dataValues.push(statusCounts.CONF_NOT_FOUND)
          colors.push(this.getCustomColor('CONF_NOT_FOUND', 0.8))
        }

        pieChartData[type] = {
          labels: labels,
          datasets: [
            {
              data: dataValues,
              backgroundColor: colors,
            },
          ],
        };
      });

      this.pieChartDataAll = pieChartData['all']
      this.pieChartDataReq = pieChartData['req']
      this.pieChartDataRes = pieChartData['resp']

      if (this.$refs.pieChartAll) {
        this.$nextTick(() => {
          this.$refs.pieChartAll.renderChart(
              this.pieChartDataAll,
              this.chartOptionsAll
          )
        })
      }
      if (this.$refs.pieChartReq) {
        this.$nextTick(() => {
          this.$refs.pieChartReq.renderChart(
            this.pieChartDataReq,
            this.chartOptionsReq
          )
        })
      }
      if (this.$refs.pieChartRes) {
        this.$nextTick(() => {
          this.$refs.pieChartRes.renderChart(
            this.pieChartDataRes,
            this.chartOptionsRes
          )
        })
      }
    },
    fetchTestTB () {
      this.pageCounter = 0
      this.activateSpinner = true
      let that = this
      that.$engine.usercompany.idUserAcc = this.idUserAcc
      this.UsersList = []
      let filterConditions = {
        IdAccountTB: this.id
      }
      that.$engine.accountTB.getTestTB(
        filterConditions
      )
      .then(resp => {
        let requests = {}
        this.generatePieChartDataStatus(resp.data.Tests)
        this.activateSpinnerTest = false
      })
      .catch(error => {
        this.activateSpinner = false
        errorMessageAlert(error, that, that.$i18n)
      })
    },

    fetchBookingTB() {
      this.pageCounter = 0
      this.activateSpinner = true
      let that = this
      that.$engine.usercompany.idUserAcc = this.idUserAcc
      this.UsersList = []
      let filterConditions = {
        IdAccountTB: this.id
      }
      that.$engine.accountTB.getBookingTB(
        filterConditions
      )
      .then(resp => {
        let requests = {}

        this.Books = resp.data.books


        that.activateSpinnerBooks = false
      })
      .catch(error => {
        this.activateSpinner = false
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    getCustomColor(key, alpha = 1) {
      let r, g, b
      r = Math.floor(Math.random() * 256)
      g = Math.floor(Math.random() * 256)
      b = Math.floor(Math.random() * 256)
      switch (key) {
        case 'InTesting': // Orange vif
          r = 230;
          g = 159;
          b = 0;
          break;
        case 'CONF_NOT_FOUND': // Violet moyen
          r = 117;
          g = 112;
          b = 179;
          break;
        case 'OK': // Bleu clair
          r = 40;
          g = 167;
          b = 69;
          break;
        case 'connector 3': // Gris neutre
        case 'NoEnrollment': // Gris neutre
          r = 153;
          g = 153;
          b = 153;
          break;
        case 'RUN': // Vert turquoise clair
          r = 0;
          g = 158;
          b = 115;
          break;
        case 'Planned': // Bleu profond
          r = 0;
          g = 114;
          b = 178;
          break;
        case 'KO': // Brun chaud
          r = 204;
          g = 0;
          b = 0;
          break;
        case 'connector 7': // Cyan clair
          r = 0;
          g = 204;
          b = 204;
          break;
        case 'AllTestOk': // Vert foncé
          r = 0;
          g = 143;
          b = 57;
          break;
        case 'NULL': // Rouge atténué
          r = 156;
          g = 163;
          b = 175;
          break;
        case '': // Vide ou non spécifié
          break;
      }
      return `rgba(${r}, ${g}, ${b}, ${alpha})`
    }
  }
}
</script>
